import { CognitoUser } from 'amazon-cognito-identity-js';
import { atom } from 'jotai';
import { UserAuthenticated } from '../../types';

// Default authenticated user structure
export const defaultUserAuthenticated: UserAuthenticated = {
  id: '',
  username: '',
  attributes: {
    email: '',
    email_verified: false,
    phone_number: '',
    phone_number_verified: false,
    sub: '',
    'custom:account': '',
  },
};

// Atom to store the authenticated user state
export const userAuthenticatedAtom = atom<UserAuthenticated>(
  defaultUserAuthenticated,
);
userAuthenticatedAtom.debugLabel = 'userAuthenticatedAtom';

// Atom to track if the user is authenticated
export const isAuthenticatedAtom = atom<boolean>(false);
isAuthenticatedAtom.debugLabel = 'isAuthenticatedAtom';

// Atom to track if the authentication is loading (only for the first load)
export const isLoadingAtom = atom<boolean>(true);
isLoadingAtom.debugLabel = 'isLoadingAtom';

// Atom to track if the authentication is fetching (for subsequent pathname changes)
export const isFetchingAtom = atom<boolean>(false);
isFetchingAtom.debugLabel = 'isFetchingAtom';

// Atom to store the Cognito user object
export const cognitoUserAtom = atom<CognitoUser | null>(null);
cognitoUserAtom.debugLabel = 'cognitoUserAtom';
